import { Layout } from "./components/Layout.js";
import { AuthGate } from "./components/auth/AuthGate.js";

const AUTH_ENABLED = Boolean(import.meta.env["VITE_CLERK_PUBLISHABLE_KEY"]);

export default function App() {
  if (AUTH_ENABLED) {
    return (
      <AuthGate>
        <Layout />
      </AuthGate>
    );
  }
  return <Layout />;
}
